export const DEVELOPER_API_REDUCER_PATH = 'developerApi';
